(function () {
  'use strict';

  // ===== Analytics =====
  // PostHog is loaded theme-wide; skip quietly if it isn't on the page.
  function track(event, props) {
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, Object.assign({ page_type: 'sm_landing' }, props || {}));
    }
  }

  // ===== Countdown =====
  function startCountdown(root) {
    var el = root.querySelector('[data-sml-countdown]');
    if (!el) return;
    var deadline = el.getAttribute('data-deadline');
    if (!deadline) return;
    var target = new Date(deadline).getTime();
    if (isNaN(target)) return;
    var dayEl = el.querySelector('[data-d]');
    var hrsEl = el.querySelector('[data-h]');
    var minEl = el.querySelector('[data-m]');
    var secEl = el.querySelector('[data-s]');
    var headEl = root.querySelector('[data-sml-countdown-head]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (dayEl) dayEl.textContent = '00';
        if (hrsEl) hrsEl.textContent = '00';
        if (minEl) minEl.textContent = '00';
        if (secEl) secEl.textContent = '00';
        if (headEl) headEl.textContent = 'Father’s Day delivery cut‑off has passed';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dayEl) dayEl.textContent = pad(d);
      if (hrsEl) hrsEl.textContent = pad(h);
      if (minEl) minEl.textContent = pad(m);
      if (secEl) secEl.textContent = pad(s);
      requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  }

  // ===== B2G1F dynamic offer bar (4 states, forecasts cheapest-kit free) =====
  function setupOfferBar(root, productId) {
    var bar = root.querySelector('[data-sml-offer]');
    if (!bar) return function () {};
    var msgEl = bar.querySelector('[data-sml-offer-msg]');
    var iconEl = bar.querySelector('[data-sml-offer-icon]');
    var buy = root.querySelector('[data-sml-buy]');
    var currency = (buy && buy.getAttribute('data-currency')) || 'GBP';

    var msgs = {
      'default':  bar.getAttribute('data-msg-default')  || 'Every 3rd kit free · mix any variety',
      'close':    bar.getAttribute('data-msg-close')    || "Add 1 more — your 3rd kit's on us",
      'action':   bar.getAttribute('data-msg-action')   || 'Claim your free kit',
      'unlocked': bar.getAttribute('data-msg-unlocked') || 'Free kit added — you saved {saved}',
      'progress': bar.getAttribute('data-msg-progress') || 'Add {n} more — next free kit on us'
    };
    var icons = { 'default': '🎁', 'close': '🎁', 'action': '🎁', 'unlocked': '🎉', 'progress': '🎁' };
    var stateClasses = ['state-default', 'state-close', 'state-action', 'state-unlocked', 'state-progress'];

    function formatMoney(pence) {
      var n = (pence || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n);
      } catch (e) {
        return (currency === 'GBP' ? '£' : '') + n.toFixed(2);
      }
    }

    // Forecast the existing automatic B2G1F discount:
    // free kits = floor(totalQty / 3); the cheapest N kits are free.
    function calcSavings(unitPrices) {
      var qty = unitPrices.length;
      var freeKits = Math.floor(qty / 3);
      if (freeKits <= 0) return 0;
      var sorted = unitPrices.slice().sort(function (a, b) { return a - b; });
      var saved = 0;
      for (var i = 0; i < freeKits; i++) saved += sorted[i] || 0;
      return saved;
    }

    function render(qty, savedPence) {
      var key, msg;
      if (qty <= 0) {
        key = 'default';
        msg = msgs['default'];
      } else if (qty === 1) {
        key = 'close';
        msg = msgs['close'];
      } else if (qty % 3 === 2) {
        key = 'action';
        msg = msgs['action'];
      } else if (qty % 3 === 0) {
        key = 'unlocked';
        msg = msgs['unlocked'].replace('{saved}', formatMoney(savedPence));
      } else {
        key = 'progress';
        var more = 3 - (qty % 3);
        msg = msgs['progress'].replace('{n}', more);
      }
      stateClasses.forEach(function (c) { bar.classList.remove(c); });
      bar.classList.add('state-' + key);
      bar.setAttribute('data-cart-state', key);
      bar.setAttribute('aria-disabled', 'true'); // bar passive now; CTA handles action
      if (msgEl) msgEl.textContent = msg;
      if (iconEl) iconEl.textContent = icons[key];
      // Trigger CTA re-render so it can morph into "Add FREE kit"
      if (buy && typeof buy._smlUpdateCta === 'function') buy._smlUpdateCta();
    }

    // Note: bar is now passive in all states. The main CTA below handles the action
    // (morphs to "Add FREE kit · FREE" at qty=2/5/8) so the customer has a single
    // obvious action surface and the chip selection determines which variety is added.

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var unitPrices = []; // pence per kit (one entry per individual unit)
          (cart.items || []).forEach(function (item) {
            if (!productId || String(item.product_id) === String(productId)) {
              var q = item.quantity || 0;
              for (var i = 0; i < q; i++) unitPrices.push(item.price || 0);
            }
          });
          var saved = calcSavings(unitPrices);
          render(unitPrices.length, saved);
        })
        .catch(function () { /* keep current */ });
    }
    refresh();
    return refresh;
  }

  // ===== Buy box =====
  function initBuyBox(root) {
    var buy = root.querySelector('[data-sml-buy]');
    if (!buy) return;
    var productId = buy.getAttribute('data-product-id');
    var refreshOffer = setupOfferBar(root, productId);

    var variantById = {};
    root.querySelectorAll('[data-sml-variant]').forEach(function (el) {
      var v = el.dataset;
      variantById[v.smlVariant] = {
        id: v.smlVariant,
        title: v.title,
        price: v.price,
        priceFormatted: v.priceFormatted,
        compareAt: v.compareAt,
        compareAtFormatted: v.compareAtFormatted,
        available: v.available === 'true'
      };
    });

    var defaultId = buy.getAttribute('data-default-variant');
    var current = variantById[defaultId] || null;

    var labelB = buy.querySelector('[data-sml-current-label]');
    var ctaPrice = buy.querySelector('[data-sml-cta-price]');
    var cta = buy.querySelector('[data-sml-cta]');
    var chips = buy.querySelectorAll('[data-sml-variant-chip]');
    var qtyDisplay = buy.querySelector('[data-sml-qty]');
    var qtyMinus = buy.querySelector('[data-sml-qty-minus]');
    var qtyPlus = buy.querySelector('[data-sml-qty-plus]');
    var qty = 1;

    function render() {
      if (!current) return;
      var isDefault = current.id === defaultId;
      if (labelB) labelB.textContent = current.title + (isDefault ? ' · MOST POPULAR' : '');
      // mark selected chip
      chips.forEach(function (c) {
        var on = c.dataset.smlVariantChip === current.id;
        c.classList.toggle('sel', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      updateCta();
    }

    function updateCta() {
      if (!current || !cta) return;
      var ctaTextEl = cta.querySelector('[data-sml-cta-text]');
      var bar = root.querySelector('[data-sml-offer]');
      var isFreeMode = bar && bar.getAttribute('data-cart-state') === 'action' && current.available;

      cta.disabled = !current.available;
      cta.classList.toggle('is-free-mode', !!isFreeMode);

      if (!current.available) {
        if (ctaTextEl) ctaTextEl.textContent = 'Sold out';
        if (ctaPrice) ctaPrice.textContent = current.priceFormatted;
      } else if (isFreeMode) {
        if (ctaTextEl) ctaTextEl.textContent = 'Add FREE kit';
        if (ctaPrice) ctaPrice.innerHTML = '<s>' + current.priceFormatted + '</s> FREE';
      } else {
        if (ctaTextEl) ctaTextEl.textContent = 'Add to basket';
        if (ctaPrice) ctaPrice.textContent = current.priceFormatted;
      }
    }

    // Expose so offer bar can re-render CTA when cart state changes
    buy._smlUpdateCta = updateCta;

    function selectVariant(id) {
      var v = variantById[id];
      if (!v) return;
      if (!current || current.id !== v.id) {
        track('landing variant selected', { variant_id: v.id, variant_title: v.title, price: v.price });
      }
      current = v;
      render();
      syncGalleryToVariant(id);
    }

    // ===== Hero gallery: thumbs + variant ↔ image linking =====
    var heroImage = root.querySelector('[data-sml-hero-image]');
    var thumbs = root.querySelectorAll('[data-sml-thumbs] .thumb');
    // Map variant ID → image URL (from chip data attrs)
    var variantToImage = {};
    chips.forEach(function (c) {
      var url = c.getAttribute('data-variant-image');
      if (url) variantToImage[c.dataset.smlVariantChip] = url;
    });

    function setHeroImage(url, activeThumb) {
      if (heroImage && url && heroImage.src !== url) {
        heroImage.classList.add('is-swapping');
        // brief fade-out → swap → fade-in
        setTimeout(function () {
          heroImage.src = url;
          heroImage.classList.remove('is-swapping');
        }, 120);
      }
      thumbs.forEach(function (t) {
        var on = t === activeThumb;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function syncGalleryToVariant(variantId) {
      var url = variantToImage[variantId];
      // Find matching thumb (by data-thumb-variant)
      var thumb = root.querySelector('[data-thumb-variant="' + variantId + '"]');
      if (!thumb) {
        // No specific thumb (e.g., Random) → fall back to "all" thumb
        thumb = root.querySelector('[data-thumb-variant="all"]');
        if (thumb && !url) url = thumb.getAttribute('data-thumb-image');
      } else if (!url) {
        url = thumb.getAttribute('data-thumb-image');
      }
      if (url) setHeroImage(url, thumb);
    }

    // Thumb click → swap image + select matching variant if any
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var vid = t.getAttribute('data-thumb-variant');
        var url = t.getAttribute('data-thumb-image');
        if (vid && vid !== 'all' && variantById[vid]) {
          selectVariant(vid); // selectVariant will call syncGalleryToVariant via render()
        } else {
          // "All" — go back to default (Random) variant
          if (defaultId) selectVariant(defaultId);
          setHeroImage(url, t);
        }
      });
    });

    chips.forEach(function (c) {
      c.addEventListener('click', function () { selectVariant(c.dataset.smlVariantChip); });
    });
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      qty = Math.max(1, qty - 1);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      track('landing quantity changed', { quantity: qty });
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qty = Math.min(99, qty + 1);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      track('landing quantity changed', { quantity: qty });
    });

    if (cta) cta.addEventListener('click', function () {
      if (!current || !current.available) return;
      cta.classList.add('is-loading');
      var ctaTextEl = cta.querySelector('[data-sml-cta-text]');
      var wasFreeMode = cta.classList.contains('is-free-mode');
      if (ctaTextEl) ctaTextEl.textContent = 'Adding…';
      track('landing add to basket clicked', {
        variant_id: current.id,
        variant_title: current.title,
        quantity: qty,
        price: current.price,
        free_kit: wasFreeMode
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(current.id, 10), quantity: qty }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function () {
          if (ctaTextEl) ctaTextEl.textContent = wasFreeMode ? '🎉 Free kit added!' : 'Added ✓';
          showToast((wasFreeMode ? '🎉 Free kit added! • ' : 'Added to basket • ') + current.title);
          // refresh dynamic B2G1F offer bar; it will call updateCta() to restore correct label
          if (refreshOffer) refreshOffer();
          // emit event so cart drawer can refresh if theme supports it
          if (window.PUB_SUB_EVENTS && window.publish) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (e) {}
          }
          setTimeout(function () {
            cta.classList.remove('is-loading');
            updateCta(); // re-render based on new cart state
          }, 1400);
        })
        .catch(function (err) {
          console.error('SML add error', err);
          cta.classList.remove('is-loading');
          updateCta();
          showToast('Could not add. Please try again.');
        });
    });

    render();
  }

  function showToast(msg) {
    var t = document.querySelector('.sml-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'sml-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  // ===== Scroll-to-buy CTAs =====
  function initScrollToBuy(root) {
    var buy = root.querySelector('[data-sml-buy]');
    if (!buy) return;
    root.querySelectorAll('[data-sml-scroll-to-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        track('landing scroll to buy clicked', { button_text: (btn.textContent || '').trim().slice(0, 80) });
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          buy.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        } catch (err) {
          buy.scrollIntoView();
        }
        // brief highlight so user notices where they landed
        buy.classList.add('sml-flash');
        setTimeout(function () { buy.classList.remove('sml-flash'); }, 1400);
      });
    });
  }

  // ===== Init =====
  function init() {
    document.querySelectorAll('.sml').forEach(function (root) {
      startCountdown(root);
      initBuyBox(root);
      initScrollToBuy(root);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
